import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustStats from '../components/TrustStats';
import AboutSection from '../components/AboutSection';
import FeatureCards from '../components/FeatureCards';
import IndustryOverview from '../components/IndustryOverview';
import KeyDifferentiators from '../components/KeyDifferentiators';
import EmployerServices from '../components/EmployerServices';
import JobSeekerServices from '../components/JobSeekerServices';
import FAQSection from '../components/FAQSection';
import CTABanner from '../components/CTABanner';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>WorkNation Labour Ltd - Staffing Agency Vancouver BC</title>
        <meta name="description" content="WorkNation Labour Ltd - Vancouver staffing agency providing construction, warehouse, food processing, agriculture, transportation & cold storage workers across BC. 200+ workers placed. WCB compliant. Get workers in 24-48 hours." />
        <link rel="canonical" href="https://worknation.ca/" />
      </Helmet>
      <Header />
      <main>
        <Hero />
        <TrustStats />
        <AboutSection />
        <FeatureCards />
        <IndustryOverview />
        <KeyDifferentiators />
        <EmployerServices />
        <JobSeekerServices />
        <FAQSection />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
